import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface CancelSubscriptionPlanChangeResponse {
  subscription_id: string;
  id_plan: string;
}

/**
 * Drop a downsell scheduled for the next billing date, and put the Stripe price back.
 *
 * Same endpoint as the client portal: staff roles go straight through `isGranted`.
 */
async function cancelSubscriptionPlanChange(
  subscriptionId: string,
  companyId: string,
  auth: Authentication
): Promise<CancelSubscriptionPlanChangeResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/subscription/cancel-plan-change',
      { subscription_id: subscriptionId, company_id: companyId },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('cancelSubscriptionPlanChange error:', e);
    throw new CancelSubscriptionPlanChangeFailure(e.message);
  }
}

export class CancelSubscriptionPlanChangeFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default cancelSubscriptionPlanChange;
